import { P } from "./permissions";

import HomeIcon from "../assets/img/home.svg?react";
import PromotionsIcon from "../assets/img/promotions.svg?react";
import AriIcon from "../assets/img/ari.svg?react";
import ResReportIcon from "../assets/img/res_report.svg?react";
import PriceCheckIcon from "../assets/img/price_check.svg?react";
import AnalyticsHubIcon from "../assets/img/analytics_hub.svg?react";
import PropertyConfigIcon from "../assets/img/property_config.svg?react";

/**
 * Feature registry — the single source of truth for every feature in the app.
 *
 * Adding a feature = add one entry here. That's it.
 * The router, sidenav, and post-login redirect all read from this list.
 *
 * Fields:
 *   id         — unique key, used as React key
 *   permission — the P.* view constant that gates this feature. Must be a leaf
 *                key, never a "x.*" wildcard: the matcher expands the requested
 *                key's prefixes, so a request for "ari.*" is only satisfied by a
 *                literal "ari.*" grant, whereas a request for "ari.view" is
 *                satisfied by either "ari.view" or an "ari.*" grant.
 *   route      — the primary URL path
 *   label      — display name in the sidenav
 *   icon       — SVG component for the sidenav
 *   menu       — true if it appears in the main sidenav menu
 */
export const features = [
  {
    id: "home",
    permission: P.Home.View,
    route: "/",
    label: "Home",
    icon: HomeIcon,
    menu: true,
  },
  {
    id: "promotions",
    permission: P.Promotions.View,
    route: "/promotions",
    label: "Promotions",
    icon: PromotionsIcon,
    menu: true,
  },
  {
    id: "ari",
    permission: P.Ari.View,
    route: "/ari",
    label: "ARI",
    icon: AriIcon,
    menu: true,
  },
  {
    id: "reservations",
    permission: P.Reservations.View,
    route: "/reservations",
    label: "Reservation Report",
    icon: ResReportIcon,
    menu: true,
  },
  {
    id: "price-check",
    permission: P.PriceCheck.Search,
    route: "/price-check",
    label: "Price Check",
    icon: PriceCheckIcon,
    menu: true,
  },
  {
    id: "analytics-hub",
    // Exception to the leaf rule: the matrix defines no analytics_hub leaf key,
    // only the "analytics_hub.*" wildcard, so gate on the wildcard directly.
    permission: P.AnalyticsHub.All,
    route: "/analytics-hub/summary",
    label: "Analytics Hub",
    icon: AnalyticsHubIcon,
    menu: false, // rendered separately (sub-menu with PowerBI pages)
  },
  {
    id: "account",
    permission: P.Account.View,
    route: "/account",
    label: "Account",
    icon: null,
    menu: false,
  },
  {
    id: "property-config",
    permission: P.PropertyConfig.View,
    route: "/property-config/information",
    label: "Property Profile",
    icon: PropertyConfigIcon,
    menu: false, // rendered separately (sub-menu with static pages)
  },
];

/** Features that appear in the main sidenav menu. */
export const menuFeatures = features.filter((f) => f.menu);

/**
 * Features eligible as a redirect target (skip account — it's a sub-page
 * opened from the header). Order matches sidenav display order, so the "first
 * accessible feature" resolver lands users on the topmost tile they can see.
 */
export const redirectFeatures = features.filter((f) => f.id !== "account");
